export default __webpack_public_path__ + "static/media/guk.b4e46a66.png";